module.exports = __webpack_public_path__ + "img/epoca-cosmeticos-thumb.ce02c3aa.jpg";